<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<p class="ded"><span class="bold">Dedication</span></p>
<p class="ded-1"><em class="italic">For my daughters Hannah and Rhiannon; with happy memories of them being small enough to wear these, and for their ongoing interest and support.</em></p>
<div class="img_container">
<img alt="images" src="images/ded-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?2c748462